export default __webpack_public_path__ + "static/media/mail.f0e04c29.svg";